import React from 'react';
import { Text } from '@common-fe/common-fe';

const Renewals = () => (
  <Text>Renewals</Text>
);

export default Renewals;
